// import React from "react";
import React, { useEffect, useState } from "react";
import { HeroSection } from "./Hero";
import { WhyChooseInfronex } from "../Home/WhyChooseInfronex";
import { PopularCourses } from "../Home/PopularCourses";
import { Link } from "react-router-dom";
import CallToAction from "./CallToAction";
import img1 from "./Logo/my-logo.png";
import logo1 from "./Logo/1.png";
import logo2 from "./Logo/2.png";
import logo3 from "./Logo/3.png";
import logo4 from "./Logo/4.png";
import logo5 from "./Logo/5.png";
import WelcomeModal1 from "./WelcomeModal1";
import { StudentReviews } from "./Logo/Review";

const Home = () => {
  useEffect(() => {
    const minLoadingTime = new Promise((resolve) => setTimeout(resolve, 1000));

    const onPageLoad = () => {
      Promise.all([minLoadingTime]).then(() => {});
    };

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
      return () => window.removeEventListener("load", onPageLoad);
    }
  }, []);

  return (
    <div className="overflow-hidden ">
      <WelcomeModal1 />
      <HeroSection />

      <section className="py-16 bg-blue-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Text FIRST on mobile */}
            <div
              className="flex flex-col order-1 md:order-none"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <h2
                className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <span className="text-gray-800">About </span>
                <span className="text-red-600">CSG Education</span>
              </h2>

              {/* On mobile we move image below heading using flex ordering */}
              <div
                className="md:hidden mb-6"
                data-aos="fade-left"
                data-aos-duration="1200"
              >
                <img
                  src="/assets/f4380aa6600ceddb1212fbad7530d74f.jpg"
                  alt="Students learning at Infronex"
                  className=" shadow-lg w-full h-auto max-h-[420px] object-cover"
                />
              </div>

              <p className="text-lg text-gray-700 leading-relaxed text-justify">
                CSG Education is a premier training institute committed to
                bridging the gap between academic education and real-world
                industry demands. We offer immersive, hands-on training programs
                in cutting-edge technologies such as full-stack development,
                cloud computing, data structures, and core programming
                languages. Our courses are designed by industry experts and
                delivered by seasoned professionals who bring valuable field
                experience into every session. At CSG Education, we focus on
                developing practical skills alongside theoretical knowledge,
                empowering our students to become industry-ready professionals
                from day one. With a learner-centric approach, modern
                curriculum, and strong industry connections, CSG Education is the
                ideal launchpad for aspiring tech professionals looking to build
                a successful career in IT.
              </p>
            </div>

            {/* Image for desktop only */}
            <div
              className="hidden md:block relative"
              data-aos="fade-left"
              data-aos-duration="1200"
            >
              <img
                src="./assets/f4380aa6600ceddb1212fbad7530d74f.jpg"
                alt="Students learning at Infronex"
                className="rounded-lg shadow-lg w-full h-auto max-h-[520px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white text-gray-900 py-12 px-6 flex flex-col items-center text-center">
        {/* 🔷 Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-blue-800 mb-3">
          CENTRE FOR TECHNICAL AND VOCATIONAL DEVELOPMENT SCIENCE
        </h2>

        {/* 🔹 Subtitle */}
        <p className="text-sm md:text-base text-gray-700 max-w-3xl leading-relaxed mb-6">
          An autonomous Body, A National Development Agency Govt. of India.
          <br />
          Registered under the Ministry of MSME, Govt. of India, Department of
          Labour Govt. of India, New Delhi.
        </p>

        {/* 🔸 Logos Row */}
        {/* <div className="flex flex-wrap justify-center items-center gap-6 mt-6">
          <img src={logo1} alt="Logo 1" className="w-16 h-16 object-contain" />
          <img src={logo2} alt="Logo 2" className="w-16 h-16 object-contain" />
          <img src={logo3} alt="Logo 3" className="w-16 h-16 object-contain" />
          <img src={logo4} alt="Logo 4" className="w-16 h-16 object-contain" />
          <img src={logo5} alt="Logo 5" className="w-16 h-16 object-contain" />
        </div> */}
        <div className="flex flex-wrap justify-center items-center gap-10 mt-10">
          <img
            src={logo1}
            alt="Logo 1"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
          <img
            src={logo2}
            alt="Logo 2"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
          <img
            src={logo3}
            alt="Logo 3"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
          <img
            src={logo4}
            alt="Logo 4"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
          <img
            src={logo5}
            alt="Logo 5"
            className="w-28 h-28 md:w-32 md:h-32 object-contain"
          />
        </div>

        {/* 🔻 Authorised Line */}
        <div className="mt-8 pt-4">
          <h3 className="text-lg md:text-xl font-semibold text-gray-800 tracking-wide">
            AUTHORISED TRAINING CENTRE
          </h3>
        </div>
      </section>

      <section
        className="py-20 px-6 md:px-20 bg-gradient-to-r from-blue-50 via-indigo-100 to-purple-50"
        data-aos="fade-up"
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between bg-white rounded-3xl shadow-2xl p-12 md:p-16 gap-10 hover:shadow-3xl transition-all duration-300">
          {/* Logo Section */}
          <div className="flex-shrink-0" data-aos="zoom-in">
            <img
              src={img1}
              alt="Infronex Logo"
              className="w-40 md:w-56 animate-pulse drop-shadow-lg"
            />
          </div>

          {/* Text Content */}
          <div className="text-center md:text-left" data-aos="fade-left">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-4 bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 bg-clip-text text-transparent">
              🤝 CSG Education Partners with Infronex IT Products & Services
            </h2>
            <p className="text-gray-700 leading-relaxed max-w-3xl text-lg">
              <strong>CSG Education</strong> has proudly collaborated with{" "}
              <strong>Infronex IT Products & Service</strong> to provide
              innovative <strong>Software Development</strong> and{" "}
              <strong>Hardware Solutions</strong>. Together, we empower students
              and professionals with real-world learning, IT infrastructure, and
              technology-driven services that inspire growth and excellence.
            </p>

            {/* Button */}
            <div className="mt-8">
              <Link
                to="/infronex"
                className="inline-block bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-all shadow-md hover:shadow-lg"
              >
                About More
              </Link>
            </div>
          </div>
        </div>
      </section>

      <PopularCourses />

      <StudentReviews />

      <WhyChooseInfronex />

      <CallToAction />
    </div>
  );
};

export default Home;
